// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__TghG_","content":"GlobalSearch_content__1cGNV"};